import { Box, CryptoIcon, Flex, FlexProps } from '@blockanalitica/ui';

export interface AssetProps extends Omit<FlexProps, 'name'> {
  address: string;
  symbol: string;
  network: string;
  iconSize?: string | number;
  name?: string;
  suffix?: string;
  showName?: boolean;
}

export default function Asset({
  address,
  symbol,
  network,
  name,
  suffix,
  showName = true,
  iconSize = '5',
  ...rest
}: AssetProps) {
  return (
    <Flex gap={['s', 'xs']} alignItems="center" {...rest}>
      <CryptoIcon
        name={symbol}
        address={address}
        network={network}
        size={iconSize}
      />
      <Flex flexDirection="column" gap="4xs">
        <Box as="span">
          {symbol} {suffix}
        </Box>
        {showName && name ? (
          <Box as="span" color="muted" fontSize="-1">
            {name}
          </Box>
        ) : null}
      </Flex>
    </Flex>
  );
}
